/**
 * Fixed identifier required by the dedicated Diamond Salon forms API.
 * Keep this value stable and do not derive it from the browser hostname.
 */
export const FORMS_SITE_NAME = 'Diamond Salon' as const
